import { render, staticRenderFns } from "./FollowsPage.vue?vue&type=template&id=050d30ab&"
import script from "./FollowsPage.vue?vue&type=script&lang=js&"
export * from "./FollowsPage.vue?vue&type=script&lang=js&"
import style0 from "./FollowsPage.vue?vue&type=style&index=0&id=050d30ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports